import { BriefOutcome, BriefType } from './types';

const NEGATIVE = [
  `${BriefType.IsNew90DayHighLow}|${BriefOutcome.OUTCOME_TRUE_90D_LOW}`,
  `${BriefType.HasPriceTargetChanged}|${BriefOutcome.OUTCOME_TRUE_REVISION_DOWN}`,
  `${BriefType.HasReportedEarnings}|${BriefOutcome.OUTCOME_TRUE_NEGATIVE_RESULT}`,
  `${BriefType.HasMajorEstimateRevision}|${BriefOutcome.OUTCOME_TRUE_REVENUE_DOWNGRADE}`,
  `${BriefType.HasMajorEstimateRevision}|${BriefOutcome.OUTCOME_TRUE_EPS_DOWNGRADE}`,
  `${BriefType.HasRecentInsiderTransactions}|${BriefOutcome.OUTCOME_TRUE_INSIDER_SELL}`,
  `${BriefType.HasBreakevenDateChange}|${BriefOutcome.OUTCOME_TRUE_BREAK_EVEN_BAD}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_CONCERNING_EVENTS_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_FINANCIAL_DATA_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_FINANCIAL_POSITION_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_STABLE_PRICE_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_NEGATIVE_EQUITY_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_DIVIDEND_SUSTAINABLE_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_REVENUE_EARNINGS_GROWTH_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_EARNINGS_QUALITY_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_DILUTION_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_MEANINGFUL_REVENUE_MAJOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_MEANINGFUL_MKT_CAP_MAJOR}`,
  `${BriefType.HasDeclaredDividend}|${BriefOutcome.OUTCOME_TRUE_DIVIDEND_DECREASE}`,
  `${BriefType.BuyOrSellOpportunity}|${BriefOutcome.OUTCOME_TRUE_OVERVALUED}`,
];

const POSITIVE = [
  `${BriefType.IsNew90DayHighLow}|${BriefOutcome.OUTCOME_TRUE_90D_HIGH}`,
  `${BriefType.HasPriceTargetChanged}|${BriefOutcome.OUTCOME_TRUE_REVISION_UP}`,
  `${BriefType.HasReportedEarnings}|${BriefOutcome.OUTCOME_TRUE_POSITIVE_RESULT}`,
  `${BriefType.HasMajorEstimateRevision}|${BriefOutcome.OUTCOME_TRUE_REVENUE_UPGRADE}`,
  `${BriefType.HasMajorEstimateRevision}|${BriefOutcome.OUTCOME_TRUE_EPS_UPGRADE}`,
  `${BriefType.HasRecentInsiderTransactions}|${BriefOutcome.OUTCOME_TRUE_INSIDER_BUY}`,
  `${BriefType.HasBreakevenDateChange}|${BriefOutcome.OUTCOME_TRUE_BREAK_EVEN_GOOD}`,
  `${BriefType.HasDeclaredDividend}|${BriefOutcome.OUTCOME_TRUE_DIVIDEND_INCREASE}`,
  `${BriefType.BuyOrSellOpportunity}|${BriefOutcome.OUTCOME_TRUE_UNDERVALUED}`,
];

const NEUTRAL = [
  `${BriefType.HasReportedEarnings}|${BriefOutcome.OUTCOME_TRUE_NEUTRAL_RESULT}`,
  `${BriefType.HasMajorEstimateRevision}|${BriefOutcome.OUTCOME_TRUE_MIXED_REVISION}`,
  `${BriefType.ValuationUpdateWith7DayPriceMove}|${BriefOutcome.OUTCOME_TRUE_PRICE_MOVE_UP}`,
  `${BriefType.ValuationUpdateWith7DayPriceMove}|${BriefOutcome.OUTCOME_TRUE_PRICE_MOVE_DOWN}`,
  `${BriefType.AnalystEstimateSurprisePostEarnings}|${BriefOutcome.OUTCOME_TRUE_NO_MISALIGNMENT}`,
  `${BriefType.AnalystEstimateSurprisePostEarnings}|${BriefOutcome.OUTCOME_TRUE_EPS_MISALIGNMENT}`,
  `${BriefType.AnalystEstimateSurprisePostEarnings}|${BriefOutcome.OUTCOME_TRUE_REVENUE_MISALIGNMENT}`,
  `${BriefType.HasRecentInsiderTransactionsDerivative}|${BriefOutcome.OUTCOME_TRUE_INSIDER_BUY}`,
  `${BriefType.HasRecentInsiderTransactionsDerivative}|${BriefOutcome.OUTCOME_TRUE_INSIDER_SELL}`,
  `${BriefType.HasDeclaredDividend}|${BriefOutcome.OUTCOME_TRUE_DIVIDEND_AFFIRMATION}`,
  `${BriefType.HasDeclaredDividend}|${BriefOutcome.OUTCOME_TRUE_DIVIDEND_CHANGE_UNCERTAIN}`,
];

const WARNING = [
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_FINANCIAL_DATA_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_FINANCIAL_POSITION_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_STABLE_PRICE_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_NEGATIVE_EQUITY_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_DIVIDEND_SUSTAINABLE_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_PROFITABILITY_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_EARNINGS_QUALITY_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_PROFIT_MARGIN_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_DILUTION_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_INSIDER_SELLING_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_MEANINGFUL_REVENUE_MINOR}`,
  `${BriefType.HasNewRisk}|${BriefOutcome.OUTCOME_TRUE_MEANINGFUL_MKT_CAP_MINOR}`,
];

export function getFill(id: string, outcome?: number | null) {
  try {
    const parsedId = (JSON.parse(id)[0] as BriefType) || undefined;
    if (
      parsedId === BriefType.HasUpcomingDividend ||
      parsedId === BriefType.HasExecutiveDeparture
    ) {
      return 'neutral';
    }

    if (
      parsedId === BriefType.BoardChange ||
      parsedId === BriefType.HasDirectorOverboarding
    ) {
      return 'bad';
    }

    if (outcome !== undefined && outcome !== null) {
      const safeId = `${parsedId}|${outcome}`;
      if (POSITIVE.includes(safeId)) {
        return 'good';
      }
      if (NEGATIVE.includes(safeId)) {
        return 'bad';
      }
      if (NEUTRAL.includes(safeId)) {
        return 'neutral';
      }
      if (WARNING.includes(safeId)) {
        return 'warning';
      }
    }
    return 'default';
  } catch {
    return 'default';
  }
}
